export default {
  "config": {
    "trial": "driving",
    "id": "sdlp-assessment-scale",
    "type": "design",
    "title": "Assessment of Lateral Position and SDLP<sup>7,29</sup>",
    "footnotes": [
      "SDLP, a measure of weaving,<sup>18</sup> during an on-road driving test (duration ~1 h) at 2 h post-dose was the primary outcome.<sup>7</sup> A blood alcohol concentration of 0.5 g/L (0.05 %) is associated with a mean SDLP increase of 2.5 cm.<sup>13</sup>"
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "driving",
    "id": "sdlp-assessment-scale",
    "data-type": "design",
    "title": "Assessment of Lateral Position and SDLP<sup>7,29</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1"
    ],
    "footnote-note1": "SDLP, a measure of weaving,<sup>18</sup> during an on-road driving test (duration ~1 h) at 2 h post-dose was the primary outcome.<sup>7</sup> A blood alcohol concentration of 0.5 g/L (0.05 %) is associated with a mean SDLP increase of 2.5 cm.<sup>13</sup>"
  }
};